import { useTranslator } from '@bluebeam/react-i18n';
import BaseInput from 'components/inputs/BaseInput';
import Label from 'components/inputs/Label';
import React, { ReactElement } from 'react';

interface Props {
  editable: boolean;
  value: string;
  onChange: (evt: React.ChangeEvent<HTMLInputElement>) => void;
}

const Location = (props: Props): ReactElement => {
  const { editable, value, onChange } = props;
  const { translate } = useTranslator(['mapView']);

  return (
    <div>
      <Label label={translate('mapView:labels.location')} required>
        <div className="light row justify-end mr3" style={{ color: '#666666' }}>
          {value.length}/140
        </div>
      </Label>
      {editable ? (
        <BaseInput
          id="update-punch-overlay-location-input"
          className="w100"
          value={value}
          onChange={onChange}
          maxLength={140}
        />
      ) : (
        <div className="font-size-5 light mt2">{value}</div>
      )}
    </div>
  );
};

export default Location;
